import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/credit-card': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M527.9 32c26.6 0 48.1 21.5 48.1 48v352c0 26.5-21.5 48-48.1 48h-479.8c-26.6 0-48.1-21.5-48.1-48v-352c0-26.5 21.5-48 48.1-48h479.8zM54.1 80c-3.3 0-6 2.7-6 6v42h479.8v-42c0-3.3-2.7-6-6-6h-467.8zM521.9 432c3.3 0 6-2.7 6-6v-170h-479.8v170c0 3.3 2.7 6 6 6h467.8zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zM384 332v40c0 6.6-5.4 12-12 12h-136c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/credit-card.js
// module id = 1720
// module chunks = 0